define([
	"dojo/_base/declare",
	"csi/state/rootStore",
	"csi/table/NewFrom",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/QueryFilterBuilder",
	"csi/reflection",
	"csi/wizard/ActionControllerMixin",
	"./StructureItemMixin",
	"SiteAdmin/SelectSet/SelectSetForm"
], function(declare,{ routerStore },NewFrom, xml, Query, QueryFilterBuilder, reflection, ActionControllerMixin, StructureItemMixin) {

	return declare([NewFrom, ActionControllerMixin, StructureItemMixin],{
		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: filter nodes by structure item
			var q = this.inherited(arguments);

			if (index == 1) {
				q = new Query();
				const { locationUrl } = routerStore;
				var ctx = this.getContext();
				var cache = ctx.cache;
				var fromSelectSetNode = ctx.getNode();
				var queryFilterURL = fromSelectSetNode.QueryFilter;

				if (xml.isValidURL(queryFilterURL)) {
					var qf = cache.addNode(queryFilterURL, function(req) {
						req.addDependencyPaths(["Child:Operands/Child:DataPointContainer"]);
					});

					var url = qf ? qf.$URL : queryFilterURL;

					QueryFilterBuilder.create(q, url, fromSelectSetNode.$URL, cache);
				}

				switch (view.defView.m_id) {
					case "AllApparelBOMs" :
						var path = reflection.PATH_PARENT;
						q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl, path);
						break;
					case "Colorways" :
						q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl);
						break;
					case "AllSKUs" :
						q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl);
						break;
					case "AllStyles" :
						q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl);
						break;
					case "SupplierItems" :
						var path = reflection.PATH_PARENT + "/" + reflection.PATH_PARENT + "/" + reflection.PATH_PARENT;
						q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl, path);
						break;
				}
			}

			return q;
		}
	});
});